import "./Snackbar.css";
import React, { useContext } from "react";
import SnackbarContext from "../../context/SnackbarContext";
import { ReactComponent as Cancel } from '../../media/common/cancel.svg';
import { ReactComponent as Check } from '../../media/common/check.svg';

export default function Snackbar() {

    const {msg, isSuccess} = useContext(SnackbarContext);

    return (
        <div
            className={'snackbar' + (isSuccess ? '' : ' snackbar--error')}
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
        >
            {isSuccess
                ? <Check fill='rgb(70, 150, 67)' />
                : <Cancel fill='rgb(175, 34, 43)' />
            }
            <span>{msg}</span>
        </div>
    );
}
